import { create } from "zustand";
import { persist, createJSONStorage } from 'zustand/middleware'
import CryptoJS from "crypto-js";
import consts from "../libs/consts"

const SECURE_LOCAL_STORAGE_HASH_KEY = "AIWITH__STORAGE__HASHKEY__20240717";

const EncryptedStorage = {
    getItem(key) {
        const value = localStorage.getItem(key);

        if (value) {
            const decryptedBytes = CryptoJS.AES.decrypt(value, SECURE_LOCAL_STORAGE_HASH_KEY)
            const decryptedValue = decryptedBytes.toString(CryptoJS.enc.Utf8);
            return decryptedValue
        }

        return value
    },
    setItem(key, value) {
        const encrypted = CryptoJS.AES.encrypt(value, SECURE_LOCAL_STORAGE_HASH_KEY).toString()
        localStorage.setItem(key, encrypted);
    },
    removeItem(key) {
        localStorage.removeItem(key);
    }
}


export const useUser = create(
    persist(
        (set, get) => ({
            isReload: false,
            token: null,
            user: null,

            bears: 0,
            options: [],

            setUser: (state) => {
                set({ [state.key]: state.value });
            },

            login: (state) => {
                set({
                    token: state?.token,
                    isReload: true
                });

                setTimeout(() => {
                    set({ isReload: false });
                }, 500)
            },
            logout: () => {
                set({
                    token: null,
                    user: null,
                    isReload: false
                });
            },
            reload: () => {
                set({ isReload: true });
                setTimeout(() => {
                    set({ isReload: false });
                }, 500)
            },
            addABear: () => set({ bears: get().bears + 1 }),
        }),
        {
            name: 'u', // name of the item in the storage (must be unique)
            storage: createJSONStorage(() => EncryptedStorage), // (optional) by default, 'localStorage' is used
        }
    )
)


export const useLang = create(
    persist(
        (set, get) => ({
            country: 'ko',
            lang: null,

            setLang: (state) => {
                set({ [state.key]: state.value });
            },
            getLang: (state) => {

                let v = get().lang?.[state?.key]?.[get().country];

                if (state?.replace) {
                    v = v?.replace(state?.replace?.key, state?.replace?.val);
                }

                return v
            },
        }),
        {
            name: 'l', // name of the item in the storage (must be unique)
            storage: createJSONStorage(() => EncryptedStorage), // (optional) by default, 'localStorage' is used
        }
    )
)

export const useHeader = create(
    (set, get) => (
        {
            mode: consts.headerMode.NORMAL,
            onBackClick: null,
            setHeaderMode: (payload) => {
                set({
                    mode: payload.mode,
                    onBackClick: payload.onBackClick ? payload.onBackClick : null,
                })
            }
        }
    )
)

export const useMenu = create(
    persist(
        (set, get) => ({
            menu: null,

            setMenu: (state) => {
                set({ [state.key]: state.value });
            },

            getMenu: (state) => {
                let findData = null
                if (get().menu && get().menu?.length > 0) {
                    findData = get().menu.find((v) => {
                        return v.idx === state.idx
                    })
                }
                return findData
            }
        }),
        {
            name: 'm', // name of the item in the storage (must be unique)
            storage: createJSONStorage(() => EncryptedStorage), // (optional) by default, 'localStorage' is used
        }
    )
)


export const usePopup = create(
    (set, get) => ({
        langPop: false,
        creditsPop: false,
        profilePop: false,
        signPop: false,
        signTermPop: false,
        menuPop: false,

        open: false,
        title: null,

        popOpen: (state) => set({
            open: true,
            title: state?.title
        }),
        popClose: () => set({
            open: false,
            title: null
        }),

        toggleLangPop: () => set({
            langPop: !(get().langPop),
            creditsPop: false,
            profilePop: false,
        }),
        toggleCreditsPop: () => set({
            langPop: false,
            creditsPop: !(get().creditsPop),
            profilePop: false,
        }),
        toggleProfilePop: () => set({
            langPop: false,
            creditsPop: false,
            profilePop: !(get().profilePop),
        }),
        openSignPop: () => set({
            signPop: true,
        }),
        closeSignPop: () => set({
            signPop: false,
        }),
        openSignTermPop: (state) => set({
            signTermPop: state,
        }),
        closeSignTermPop: () => set({
            signTermPop: false,
        }),
        openMenu: () => set({
            menuPop: true,
        }),
        closeMenu: () => set({
            menuPop: false,
        }),


    })
)

export const useConfig = create((set, get) => ({
    config: "",
    setConfig: (payload) => {

    }
}))

export const usePrompt = create((set, get) => ({
    promptList: [],
    setPromptList: (state) => {
        set({ [state.key]: state.value });
    }
}))

export const useLoading = create((set, get) => ({
    isLoading: false,
    setLoading: (state) => {
        set({ isLoading: state })
    }
}))
